/**
 * File type configuration — shared across all linked-files components.
 */

export const FILE_TYPE_CONFIG = {
  script:     { label: 'Script',     icon: '📝', color: 'bg-blue-500',    text: 'text-blue-500',    light: 'bg-blue-500/10 text-blue-500 border-blue-500/20' },
  storyboard: { label: 'Storyboard', icon: '🎨', color: 'bg-purple-500',  text: 'text-purple-500',  light: 'bg-purple-500/10 text-purple-500 border-purple-500/20' },
  footage:    { label: 'Footage',    icon: '🎬', color: 'bg-red-500',     text: 'text-red-500',     light: 'bg-red-500/10 text-red-500 border-red-500/20' },
  reference:  { label: 'Reference',  icon: '📌', color: 'bg-amber-500',   text: 'text-amber-500',   light: 'bg-amber-500/10 text-amber-500 border-amber-500/20' },
  audio:      { label: 'Audio',      icon: '🎵', color: 'bg-emerald-500', text: 'text-emerald-500', light: 'bg-emerald-500/10 text-emerald-500 border-emerald-500/20' },
  document:   { label: 'Document',   icon: '📄', color: 'bg-indigo-500',  text: 'text-indigo-500',  light: 'bg-indigo-500/10 text-indigo-500 border-indigo-500/20' },
  image:      { label: 'Image',      icon: '🖼️', color: 'bg-pink-500',    text: 'text-pink-500',    light: 'bg-pink-500/10 text-pink-500 border-pink-500/20' },
  other:      { label: 'Other',      icon: '📦', color: 'bg-gray-500',    text: 'text-gray-500',    light: 'bg-gray-500/10 text-gray-500 border-gray-500/20' },
};

export const ALL_FILE_TYPES = Object.keys(FILE_TYPE_CONFIG);

/**
 * Provider inference from a URL — purely cosmetic, used to render a short
 * host label like "Google Drive" or "Dropbox" beside the link. Falls back to
 * the hostname itself when we don't recognise the host.
 */
export function inferProvider(url) {
  if (!url) return { label: 'Link', host: '' };
  let host;
  try {
    host = new URL(url).hostname.toLowerCase();
  } catch {
    return { label: 'Link', host: '' };
  }
  if (host.includes('drive.google') || host.includes('docs.google')) return { label: 'Google Drive', host };
  if (host.includes('dropbox.com')) return { label: 'Dropbox', host };
  if (host.includes('onedrive.live') || host.includes('sharepoint')) return { label: 'OneDrive', host };
  if (host.includes('frame.io')) return { label: 'Frame.io', host };
  if (host.includes('vimeo.com')) return { label: 'Vimeo', host };
  if (host.includes('youtube.com') || host.includes('youtu.be')) return { label: 'YouTube', host };
  if (host.includes('notion.so')) return { label: 'Notion', host };
  return { label: host.replace(/^www\./, ''), host };
}
